import React from 'react'
import HealthInformation from './HealthInformation'

export default function CriticalIllness () {
  return <HealthInformation path='ci' />
}